/* Aviso del inicio para el capacitador técnico: capacitaciones asignadas
 * pendientes (programadas o pendientes de cierre).
 *
 * - No pinta nada si no tiene ninguna, o si el usuario no es capacitador (el
 *   endpoint responde 403 y se ignora a propósito).
 * - Cada fila abre el detalle de esa capacitación en /solicitudes-capacitacion
 *   (pestaña Asignadas); la tarjeta abre la lista completa.
 */
import { useIonViewWillEnter } from "@ionic/react";
import { Typography } from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { fmtFechaHora } from "src/components/SolicitudCapacitacionCampos";
import SolicitudCapacitacionAPI, { SolicitudCapacitacion } from "src/services/solicitudCapacitacion";

const MAX_FILAS = 3;

const CapacitacionesPendientesCard: React.FC = () => {
  const history = useHistory();
  const [items, setItems] = useState<SolicitudCapacitacion[]>([]);

  const cargar = useCallback(() => {
    SolicitudCapacitacionAPI.asignadas()
      .then((r) =>
        setItems(
          (r.data.datos || []).filter((s) => s.estado === "PROGRAMADA" || s.estado === "PENDIENTE_CIERRE")
        )
      )
      .catch(() => setItems([]));
  }, []);

  useEffect(() => {
    cargar();
  }, [cargar]);

  // El inicio queda montado: al volver (p. ej. después de cerrar una) se refresca.
  useIonViewWillEnter(() => {
    cargar();
  }, [cargar]);

  if (!items.length) return null;

  const porCerrar = items.filter((s) => s.puede_cerrar).length;
  const ir = (id?: number) =>
    history.push(`/solicitudes-capacitacion?tab=asignadas${id ? `&id=${id}` : ""}`);

  return (
    <div className="container mt-1">
      <div
        onClick={() => ir()}
        style={{
          cursor: "pointer",
          background: "#fff",
          borderRadius: 10,
          borderLeft: "6px solid var(--garnet, #910434)",
          boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
          padding: "12px 14px",
          marginBottom: 10,
        }}
      >
        <Typography variant="caption" style={{ color: "var(--garnet, #910434)", fontWeight: 700 }}>
          🎓 CAPACITACIONES ASIGNADAS
        </Typography>
        <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
          {items.length === 1
            ? "Tenés 1 capacitación pendiente"
            : `Tenés ${items.length} capacitaciones pendientes`}
          {porCerrar > 0 && (
            <span style={{ color: "#c0392b", fontSize: 13, fontWeight: 600 }}>
              {" "}
              · {porCerrar} para cerrar
            </span>
          )}
        </Typography>

        {items.slice(0, MAX_FILAS).map((s) => (
          <div
            key={s.solicitud_id}
            onClick={(e) => {
              e.stopPropagation();
              // Si ya se puede cerrar, va directo a la pantalla de cierre.
              if (s.puede_cerrar) history.push(`/solicitudes-capacitacion/${s.solicitud_id}/cierre`);
              else ir(s.solicitud_id);
            }}
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 8,
              fontSize: 13,
              padding: "6px 0",
              borderTop: "1px solid #eee",
            }}
          >
            <span style={{ flex: 1 }}>
              N° {s.solicitud_id} · {s.ps_nombre}
            </span>
            <span style={{ whiteSpace: "nowrap", color: s.puede_cerrar ? "#c0392b" : "#555" }}>
              {s.puede_cerrar ? "Cerrar" : fmtFechaHora(s.fecha_programada, s.hora_programada)}
            </span>
          </div>
        ))}

        <Typography variant="caption" style={{ color: "var(--garnet, #910434)", fontWeight: 600 }}>
          {items.length > MAX_FILAS ? `Ver las ${items.length} →` : "Tocá para ver el detalle →"}
        </Typography>
      </div>
    </div>
  );
};

export default CapacitacionesPendientesCard;
